import { Contract, NewContractRequest } from '@/models/Contracts';
import {
  getAllContracts, postNewContract
} from '@/services/ContractService';
import { createGlobalState } from '@vueuse/core';
import { reactive, ref } from 'vue';

const useContractOverview = createGlobalState(() => {
  const allContracts = ref<Contract[]>([]);
  const isContractOverviewLoading = ref(false);

  const fetchContracts = async () => {
    isContractOverviewLoading.value = true;
    allContracts.value = await getAllContracts();
    isContractOverviewLoading.value = false;
  };

  const newContractProperties = reactive<NewContractRequest>({
    client: undefined,
    contractPartnerId: '',
    message: ''
  });

  const submitNewContract = async () => {
    const contract = await postNewContract(newContractProperties);
    allContracts.value.push(contract);
    newContractProperties.client = undefined;
    newContractProperties.contractPartnerId = '';
    newContractProperties.message = '';
    return contract;
  };

  return {
    fetchContracts,
    isContractOverviewLoading,
    allContracts,
    newContractProperties,
    submitNewContract,
  };
});

export default useContractOverview;
